// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAbxrJTvwTTj26KlYrgceue7AId4Ms9XrU",
  authDomain: "mpcwebsite2.firebaseapp.com",
  databaseURL: "https://mpcwebsite2-default-rtdb.firebaseio.com",
  projectId: "mpcwebsite2",
  storageBucket: "mpcwebsite2.appspot.com",
  messagingSenderId: "352653283427",
  appId: "1:352653283427:web:6122521dc24dd16f4ba856",
  measurementId: "G-DKK7QCP4FS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
 const projectFunctions = getFunctions(app);

export { app, analytics, projectFunctions };